import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            px: 3,
            backgroundColor: '#f0f4ff',
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 64, color: '#d32f2f', mb: 2 }} />

          <Typography variant="h5" sx={{ fontWeight: 700, color: '#0d47a1', mb: 1 }}>
            Ocurrió un error inesperado
          </Typography>

          <Typography variant="body1" sx={{ color: '#555', mb: 3, maxWidth: 420 }}>
            La aplicación encontró un problema. Por favor recarga la página o
            contacta al administrador si el error persiste.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={this.handleReload}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '12px', px: 4, py: 1.2 }}
          >
            Volver al inicio
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
